import ElButtonGroup from './ButtonGroup.vue'

/* istanbul ignore next */
ElButtonGroup.install = function (app) {
  app.component(ElButtonGroup.name, ElButtonGroup)
}

export default ElButtonGroup
